importTableDirective.$inject = ['adminApi']
export default function importTableDirective(adminApi) {
  return {
    restrict: 'EA',
    scope: {
      imports: '=',
      completed: '=',
      hideDomain: '=',
      tableId: '@'
    },
    link: function(scope) {
      scope.search = ''
      if (scope.completed) {
        scope.orderKey = 'imported_at'
        scope.reverse = true
      } else {
        scope.orderKey = 'created_at'
        scope.reverse = true
      }

      scope.sort = function(key) {
        if (scope.orderKey === key) {
          scope.reverse = !scope.reverse
        } else {
          scope.reverse = false
        }
        scope.orderKey = key
      }

      scope.deleteImport = function(index, importUuid) {
        var sure = confirm('Are you sure you want to delete/abort this import?')
        if (sure) {
          adminApi.deleteImport(importUuid).then(function(response) {
            if (response === true) {
              console.log('Deleted')
              scope.imports.splice(index, 1)
            }
          })
        }
      }
    },
    template: require('./../../partials/import_wizard/_importTable.html')
  }
}
